import { type UserInAdmin, type CurrentUserIguanaObject } from 'Users';
import { type ProgramFamily } from 'Program';

export const getProgramFamilyFormDatum = (user: CurrentUserIguanaObject | UserInAdmin, programFamily: ProgramFamily) =>
    user.programFamilyFormData.find(programFamilyFormDatum => programFamilyFormDatum.programFamily === programFamily);
